module.exports = __webpack_public_path__ + "/images/ico-cover-pig.c676917.svg";